import FastPaceWarningModal from "@/Modals/FastPaceWarningModal"
import { setModalData } from "@/store/globalSlice"
import { useAppDispatch, useAppSelector } from "@/store/hooks"
import { socket } from "@/utils/utils"

/**
 * The in-game half of the fast-pace warning (the panel itself is
 * FastPaceWarningModal, shared with the lobby toggle).
 *
 * Everywhere else, asking for fast pace mid-game opens a vote: the proposal
 * sits on the table for 45 seconds and somebody else has to agree to it. A
 * table of bots has nobody to ask — bots always accept — so the server switches
 * the room over on the click itself (see fastPaceHelpers.startFastPaceVote).
 * That is the whole reason this exists: the one case where the change is
 * instant is also the case where the player least likely to know what they are
 * asking for is the only one asking. So the pause the vote would have given
 * them is put back.
 *
 * Shown once per click, not once per game — a player who backs out and thinks
 * better of it a few turns later gets the same explanation again. The switch is
 * one-way and permanent, so there is nothing to un-warn about.
 */
const FastPaceNewPlayerConfirmModal: React.FC = () => {
  const dispatch = useAppDispatch()
  const gameId = useAppSelector((state) => state.global.myGame?.id)

  const close = () =>
    dispatch(setModalData({ fastPaceNewPlayerConfirm: { visible: false } }))

  return (
    <FastPaceWarningModal
      onCancel={close}
      onConfirm={() => {
        close()
        socket.emit("game.propose-fast-pace", gameId || "")
      }}
    />
  )
}

export default FastPaceNewPlayerConfirmModal
